import Avatar from "./Avatar";
import { pastelColors, tagTextColors } from "../hooks/useAddProductConfig";
export default function TareasHeader({
  selectedProject,
  GroupIcon,
  groupColor,
  uniqueAssigned,
  assignedUsers,
  tagsArray,
  formatDate,
  searchInput,
  setSearchInput,
  optionsRef,
  showOptions,
  setShowOptions,
  isComplete,
  toggleProjectFlag,
  handleDeleteProject,
  openNewListModal,
  handleToggleFavorito,
  setSelectedProject,
}) {
  return (
    <div className="project-header">
      {/* Fila superior: título */}
      <div className="header-top-row">
        <h2
          className="project-title"
          style={{ display: "flex", alignItems: "center", gap: 8 }}
        >
          {GroupIcon ? (
            <GroupIcon size={20} style={{ color: groupColor }} />
          ) : (
            <i
              className="bi bi-folder-fill"
              style={{ fontSize: 22, color: groupColor }}
            />
          )}

          {selectedProject.projectName}

          {selectedProject?.favorito ? (
            <i
              className="bi bi-star-fill"
              style={{ color: "#FACC15", cursor: "pointer" }}
              onClick={() => handleToggleFavorito(false)}
            />
          ) : (
            <i
              className="bi bi-star"
              style={{ color: "#A3A3A3", cursor: "pointer" }}
              onClick={() => handleToggleFavorito(true)}
            />
          )}
        </h2>
      </div>

      {/* Fila media: info del proyecto */}
      <div className="header-bottom-row">
        <div className="info-left">
          <div className="info-item">
            <span style={{ fontWeight: 600, color: "#464F60" }}>
              Invitados:
            </span>
            <div className="avatares-group">
              {uniqueAssigned.length > 0
                ? uniqueAssigned
                    .slice(0, 3)
                    .map((u) => (
                      <Avatar
                        key={u.id}
                        userId={u.id}
                        size={30}
                        className="mr-1"
                      />
                    ))
                : [0, 1, 2].map((i) => (
                    <Avatar key={i} userId={null} size={30} className="mr-1" />
                  ))}
              {assignedUsers.length > 3 && (
                <span className="avatares-count">
                  +{assignedUsers.length - 3}
                </span>
              )}
            </div>
          </div>

          <div className="info-item">
            <span style={{ fontWeight: 600, color: "#464F60" }}>Fecha:</span>
            <span className="value">
              {selectedProject?.startDate || selectedProject?.dueDate ? (
                <>
                  {selectedProject?.startDate
                    ? formatDate(selectedProject.startDate)
                    : "—"}
                  {selectedProject?.startDate &&
                    selectedProject?.dueDate &&
                    " — "}
                  {selectedProject?.dueDate
                    ? formatDate(selectedProject.dueDate)
                    : "—"}
                </>
              ) : (
                "Sin fecha"
              )}
            </span>
          </div>

          <div className="info-item">
            <span style={{ fontWeight: 600, color: "#464F60" }}>
              Etiquetas:
            </span>
            {tagsArray.length > 0 ? (
              tagsArray.map((tag, idx) => (
                <span
                  key={idx}
                  style={{
                    display: "inline-block",
                    margin: "0 5px 5px 0",
                    padding: "4px 8px",
                    borderRadius: 4,
                    fontWeight: "bold",
                    fontSize: 13,
                    backgroundColor: pastelColors[idx % pastelColors.length],
                    color: tagTextColors[idx % tagTextColors.length],
                  }}
                >
                  {tag}
                </span>
              ))
            ) : (
              <span className="tag">Sin etiquetas</span>
            )}
          </div>
        </div>
      </div>

      {/* Fila inferior: barra de herramientas */}
      <div className="header-tools">
        <div className="tools-left">
          <button className="view-toggle-btn active">
            <i className="bi bi-grid" /> Cuadrícula
          </button>
          <button className="view-toggle-btn">
            <i className="bi bi-clock-history" /> Timeline
          </button>
          <button className="view-toggle-btn">
            <i className="bi bi-list" /> Lista
          </button>
        </div>

        <div className="tools-right">
          <div className="buscar-input">
            <i className="bi bi-search" />
            <input
              type="text"
              className="buscar-input"
              placeholder="Buscar Tareas..."
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
          </div>

          <button
            ref={optionsRef}
            className="options-btn"
            style={{ position: "relative" }}
            onClick={() => setShowOptions((prev) => !prev)}
          >
            <i className="bi bi-sliders" /> Opciones
            {showOptions && (
              <div className="menu-list menu-list-project">
                <button
                  className="menu-button"
                  onClick={() => {
                    setShowOptions(false);
                    setSelectedProject({ ...selectedProject, modo: "editar" });
                  }}
                >
                  <i className="bi bi-pencil" style={{ marginRight: 6 }} />{" "}
                  Editar
                </button>

                <button
                  className="menu-button deleteMenu-button"
                  onClick={() => {
                    setShowOptions(false);
                    handleDeleteProject();
                  }}
                >
                  <i className="bi bi-trash" style={{ marginRight: 6 }} />{" "}
                  Eliminar
                </button>

                {!isComplete && (
                  <>
                    <button
                      className="menu-button"
                      onClick={() => {
                        setShowOptions(false);
                        toggleProjectFlag("programado");
                      }}
                    >
                      <i
                        className="bi bi-clock-history"
                        style={{ marginRight: 6 }}
                      />
                      {selectedProject?.programado
                        ? "Quitar de Programados"
                        : "Marcar como Programado"}
                    </button>

                    <button
                      className="menu-button"
                      onClick={() => {
                        setShowOptions(false);
                        toggleProjectFlag("urgente");
                      }}
                    >
                      <i
                        className="bi bi-exclamation-circle"
                        style={{ marginRight: 6 }}
                      />
                      {selectedProject?.urgente
                        ? "Quitar Urgente"
                        : "Marcar como Urgente"}
                    </button>
                  </>
                )}

                <button
                  className="menu-button"
                  onClick={() => {
                    setShowOptions(false);
                    toggleProjectFlag("completo");
                  }}
                >
                  <i
                    className="bi bi-check2-square"
                    style={{ marginRight: 6 }}
                  />
                  {isComplete ? "Quitar de Completos" : "Marcar como Completo"}
                </button>
              </div>
            )}
          </button>

          <button
            className="new-task-button"
            onClick={() => openNewListModal(null)}
          >
            <i className="bi bi-plus-lg" /> Nuevo
          </button>
        </div>
      </div>
    </div>
  );
}
